// format.js - 统一的格式化工具（避免各组件重复写同一套日期格式化代码）

/**
 * 格式化为 YYYY-MM-DD HH:mm:ss
 * 支持：Date、时间戳、可解析的日期字符串；已是该格式的字符串原样返回；无法解析则原样返回。
 */
export function formatDateTime(value) {
	if (value === null || value === undefined || value === '') {
		return '';
	}
	if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)) {
		return value;
	}
	const date = new Date(value);
	if (isNaN(date.getTime())) {
		return typeof value === 'string' ? value : '';
	}
	const pad = (n) => String(n).padStart(2, '0');
	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
		`${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

/**
 * 格式化为 yyyy/mm/dd hh:mm:ss（Excel 导入使用的格式）
 */
export function formatDateTimeSlashes(value) {
	const s = formatDateTime(value);
	return s ? s.replace(/-/g, '/') : '';
}
